<template>
  <section class="contact-us-container" ref="contactUsContainer">
    <div class="contact-us-hero">
      <h1 class="contact-us-title">Get in touch with us</h1>
      <p class="contact-us-subtitle">Punya pertanyaan seputar produk, pemesanan, atau karier? Tim kami siap membantu.</p>
    </div>

    <div class="contact-us-body">
      <div class="contact-us-card-grid">
        <div class="contact-us-card">
          <div class="contact-us-icon-wrapper">
            <img class="contact-us-icon" src="https://raw.githubusercontent.com/hanifsyahsn/dumons-asset/refs/heads/main/images/gps%20(1).png" alt="location">
          </div>
          <p class="contact-us-card-title">Address</p>
          <p class="contact-us-card-text">Jl Raya Boyolali - Semarang km 0.2 Winong, Boyolali, Jawa Tengah, Indonesia 57315</p>
          <a class="contact-us-button" :href="mapsUrl" target="_blank" rel="noopener">Buka Google Maps</a>
        </div>

        <div class="contact-us-card">
          <div class="contact-us-icon-wrapper">
            <img class="contact-us-icon" src="https://raw.githubusercontent.com/hanifsyahsn/dumons-asset/refs/heads/main/images/customer-service%20(1).png" alt="customer support">
          </div>
          <p class="contact-us-card-title">Customer Support</p>
          <div class="contact-us-card-rows">
            <a class="contact-us-row" href="tel:+622763340069">
              <span class="contact-us-row-label">Phone</span>
              <span class="contact-us-row-value">(0276) 334 0069</span>
            </a>
            <a class="contact-us-row" :href="whatsappUrl" target="_blank" rel="noopener">
              <span class="contact-us-row-label">Whatsapp</span>
              <span class="contact-us-row-value">0851 5912 2501</span>
            </a>
          </div>
          <a class="contact-us-button contact-us-button-whatsapp" :href="whatsappUrl" target="_blank" rel="noopener">Chat via Whatsapp</a>
        </div>

        <div class="contact-us-card">
          <div class="contact-us-icon-wrapper">
            <img class="contact-us-icon" src="https://raw.githubusercontent.com/hanifsyahsn/dumons-asset/refs/heads/main/images/mail%20(1).png" alt="email">
          </div>
          <p class="contact-us-card-title">Email</p>
          <p class="contact-us-card-label">Admin & Career</p>
          <p class="contact-us-card-text contact-us-email">dumonscoatingindonesia@gmail.com</p>
          <a class="contact-us-button" href="mailto:dumonscoatingindonesia@gmail.com">Kirim Email</a>
        </div>
      </div>

      <div class="contact-us-map-wrapper">
        <iframe
            class="contact-us-map"
            title="Lokasi PT Dumons Cat Indonesia"
            src="https://maps.google.com/maps?q=-7.5166046,110.5915625&z=16&output=embed"
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ContactUsPage',
  data() {
    return {
      mapsUrl: 'https://maps.app.goo.gl/AmS1U8RRRzUTA8Ew6',
      whatsappUrl: 'https://wa.me/6285159122501?text=Chat%20with%20our%20admin'
    }
  },
  mounted() {
    setTimeout(() => {
      this.$refs.contactUsContainer.setAttribute('active', '')
    }, 0)
  }
}

</script>

<style>

.contact-us-container {
  opacity: 0;
  width: 100%;
  min-width: 320px;
  min-height: 100vh;
  min-height: 100dvh;
  background-color: var(--light-grey);
  transition: opacity 500ms ease;
}

.contact-us-container[active] {
  opacity: 1;
}

.contact-us-hero {
  width: 100%;
  min-height: 190px;
  padding: 64px 16px 28px;
  box-sizing: border-box;
  background-color: black;
  border-bottom: 10px solid var(--dodger-blue);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  @media (--large) {
    min-height: 240px;
    padding-top: 72px;
  }
}

.contact-us-title {
  font-family: "Bebas Neue", sans-serif;
  font-weight: 400;
  font-size: 40px;
  line-height: 1;
  color: var(--white);
  @media (--large) {
    font-size: 56px;
  }
}

.contact-us-subtitle {
  margin-top: 10px;
  max-width: 520px;
  color: var(--shaddow-white);
  font-size: 15px;
  line-height: 1.5;
  @media (--large) {
    font-size: 17px;
  }
}

.contact-us-body {
  width: 100%;
  max-width: var(--page-max-width);
  margin: 0 auto;
  padding: 32px 16px 48px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 24px;
  @media (--medium) {
    padding: 48px 24px 64px;
    gap: 32px;
  }
  @media (--large) {
    padding: 64px 48px 80px;
  }
}

.contact-us-card-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  @media (--large) {
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
  }
}

.contact-us-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 28px 20px;
  border-radius: 12px;
  background-color: var(--white);
  border-top: 4px solid var(--dodger-blue);
  transition: transform 200ms ease, box-shadow 200ms ease;
}

@media (hover: hover) {
  .contact-us-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 10px 24px rgba(0, 0, 0, 0.12);
  }
}

.contact-us-icon-wrapper {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background-color: var(--light-grey);
  display: flex;
  align-items: center;
  justify-content: center;
}

.contact-us-icon {
  width: 32px;
  height: 32px;
  object-fit: contain;
}

.contact-us-card-title {
  margin-top: 14px;
  font-family: "Bebas Neue", sans-serif;
  font-size: 28px;
  letter-spacing: 1px;
  color: var(--black);
}

.contact-us-card-label {
  margin-top: 4px;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: #666;
}

.contact-us-card-text {
  margin: 6px 0 18px;
  max-width: 280px;
  font-size: 16px;
  line-height: 1.5;
  color: var(--black);
}

.contact-us-email {
  word-break: break-all;
}

.contact-us-card-rows {
  margin: 6px 0 18px;
  width: 100%;
  max-width: 280px;
  display: flex;
  flex-direction: column;
}

.contact-us-row {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  padding: 8px 0;
  border-bottom: 1px solid var(--grey);
  text-decoration: none;
  cursor: pointer;
  &:last-child {
    border-bottom: none;
  }
}

.contact-us-row-label {
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: #666;
  cursor: pointer;
}

.contact-us-row-value {
  font-size: 16px;
  font-weight: 500;
  color: var(--black);
  cursor: pointer;
  transition: color 200ms ease;
}

@media (hover: hover) {
  .contact-us-row:hover .contact-us-row-value {
    color: var(--corn-flower-blue);
  }
}

.contact-us-button {
  margin-top: auto;
  display: inline-block;
  padding: 10px 22px;
  border-radius: 6px;
  background-color: black;
  font-family: "Bebas Neue", sans-serif;
  font-size: 18px;
  letter-spacing: 1px;
  color: var(--white);
  text-decoration: none;
  cursor: pointer;
  transition: background-color 200ms ease, transform 200ms ease;
  &:active {
    transform: scale(0.95);
  }
}

@media (hover: hover) {
  .contact-us-button:hover {
    background-color: var(--dodger-blue);
  }
}

.contact-us-button-whatsapp {
  background-color: #25D366;
  color: black;
}

.contact-us-map-wrapper {
  width: 100%;
  height: 280px;
  border-radius: 12px;
  overflow: hidden;
  background-color: var(--grey);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.15);
  @media (--large) {
    height: 400px;
  }
}

.contact-us-map {
  width: 100%;
  height: 100%;
  border: 0;
}

</style>
